/** @format */

import * as React from 'react';

import {cn, addTWPrefixToClasses} from '@/lib/utils';

const Input = React.forwardRef(({className, preventChangeOnWheel, type, ...props}, ref) => {
    const borderRadiusClass = !className?.includes('tw-rounded-') ? 'tw-rounded-md' : '';
    const paddingXClass = !className?.includes('tw-px-') ? 'tw-px-3' : '';
    const paddingYClass = !className?.includes('tw-py-') ? 'tw-py-2' : '';
    const paddingClass = `${paddingYClass} ${paddingXClass}`;

    return (
        <input
            type={type}
            className={cn(
                `tw-flex tw-h-10 tw-w-full tw-border ${borderRadiusClass} ${paddingClass} tw-border-info tw-bg-white tw-text-sm tw-ring-offset-background file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium file:tw-text-foreground placeholder:tw-text-gray-500 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50`,
                addTWPrefixToClasses(className)
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export {Input};
